<h4 class="certification-name">{{ professional.firstName }} {{ professional.lastName }}</h4>
<div class="show-more" *ngIf="!short">
    <div class="show-more-details" *ngIf="showMore">
        <p class="show-more-details-item">
            <label class="label">Profile:</label> <span>{{ profileTypeLabel }}</span>
        </p>
        <p class="show-more-details-item">
            <label class="label">Email:</label> <span>{{ professional.email }}</span>
        </p>
        <p class="show-more-details-item" *ngIf="professional.organizationProfileId">
            <label class="label">Internal ID:</label> <span>{{ professional.organizationProfileId }}</span>
        </p>
        <ng-container *ngIf="professional.organizationOfficeName">
            <p class="show-more-details-item" *ngIf="professional.organizationCountryName">
                <label class="label">Country:</label> <span>{{ professional.organizationCountryName }}</span>
            </p>
            <p class="show-more-details-item" *ngIf="professional.organizationRegionName">
                <label class="label">{{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}:</label>
                <span>{{ professional.organizationRegionName }}</span>
            </p>
            <p class="show-more-details-item" *ngIf="professional.organizationOfficeName">
                <label class="label">{{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}:</label>
                <span>{{ professional.organizationOfficeName }}</span>
            </p>
        </ng-container>
        <p class="show-more-details-item" *ngIf="permissions.organizationRolesFeatureFlag">
            <label class="label">Role:</label>
            <span *ngIf="professional.organizationRoleName">{{ professional.organizationRoleName }}</span>
            <span *ngIf="!professional.organizationRoleName && !permissions.personalInfoEdit">N/A</span>
            <span *ngIf="!professional.organizationRoleName && permissions.personalInfoEdit">
                <a
                    class="cm-link"
                    (click)="$event.stopPropagation()"
                    [routerLink]="['/organization/settings/users/' + professional.id]"
                    [queryParams]="{ editRole: true }"
                    >Click here to add</a
                >
            </span>
        </p>
    </div>
    <span class="cm-link" (click)="toggleDetails($event)"> {{ showDetailsLabel }} </span>
</div>
